// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import some from 'lodash/some'

// Actions
import connectActions from 'utils/connectActions'
import { patchProposalLazy } from 'actions/proposals'
import { unsplashDownload } from 'actions/integrations'

// Selectors
import { connectGetters } from 'react-redux-getters'
import { makeGetProposal } from 'selectors/proposals'

// Atoms
import { AppProgressActivator, AppProgressLoadable } from 'atoms/AppProgress'
import { AppSavingActivator } from 'atoms/AppSaving'

// Components
import UnsplashSearch from 'components/Integrations/Unsplash/Search'

const mapActionsToProps = {
  patchProposalLazyAction: patchProposalLazy,
  unsplashDownloadAction: unsplashDownload,
}

const mapGettersToProps = () => {
  const getProposal = makeGetProposal()
  return (state, ownProps) => ({
    proposalGetter: getProposal(state, { proposalUuid: ownProps.proposalUuid }),
  })
}

export default
@connectActions(mapActionsToProps)
@connectGetters(mapGettersToProps)
class ProposalUnsplash extends Component {
  static propTypes = {
    patchProposalLazyAction: PropTypes.object.isRequired,
    unsplashDownloadAction: PropTypes.object.isRequired,
    proposalGetter: PropTypes.object.isRequired,
    proposalUuid: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  isPending = () => {
    const { unsplashDownloadAction, patchProposalLazyAction } = this.props
    return some([unsplashDownloadAction, patchProposalLazyAction], { isPending: true })
  }

  handleResultSelect = async (searchResult) => {
    const {
      patchProposalLazyAction, unsplashDownloadAction,
      proposalUuid, onClose, proposalGetter
    } = this.props

    if (this.isPending()) return

    const proposal = proposalGetter.data
    const { user, links } = searchResult

    try {
      const { url } = await unsplashDownloadAction.run({
        params: [links.download_location],
        updateComponentOnSuccess: false,
      })

      const proposalData = {
        image: url,
        data: {
          ...proposal.data,
          unsplash: {
            user: {
              name: user.name,
              link: user.links.html
            },
          }
        }
      }

      await patchProposalLazyAction.run({
        params: [proposalUuid, proposalData],
        updateComponentOnSuccess: false,
      })

      onClose()
    } catch (e) {
      // do nothing
    }
  }

  render() {
    const { proposalGetter, onClose } = this.props
    return (
      <Fragment>
        <AppProgressLoadable loader={proposalGetter} />
        { this.isPending() && (
          <Fragment>
            <AppProgressActivator />
            <AppSavingActivator />
          </Fragment>
        ) }
        { proposalGetter.isSucceded && (
          <UnsplashSearch
            onCancel={onClose}
            onResultSelect={this.handleResultSelect}
          />
        ) }
      </Fragment>
    )
  }
}
